// @flow

import type {PlanningState, PlanningItem, Action} from "../types"
import {isBefore, isWithinRange, compareAsc} from "date-fns"

const initialState: PlanningState = {
  entities: [],
  babyToken: null,
}

const planning = (state: PlanningState = initialState, action: Action) => {
  switch (action.type) {
    case "SET_PLANNING":
      return {
        ...state,
        entities: action.planning,
      }
    case "SET_PLANNING_BABY":
      return {
        ...state,
        babyToken: action.babyToken,
      }
    default:
      return state
  }
}

// selectors
export const getPlanningItemsForRange = (
  items: $ReadOnlyArray<PlanningItem>,
  from: Date,
  to: Date,
  andUndone: boolean = false
): $ReadOnlyArray<PlanningItem> => {
  let foundItems = items.filter((planningItem) =>
    isWithinRange(planningItem.date, from, to)
  )
  if (!andUndone) {
    return foundItems
  }
  return foundItems
    .concat(items.filter((planningItem) => isBefore(planningItem.date, from)))
    .sort((a, b) => compareAsc(a.date, b.date))
}

export default planning
